import { Injectable, isDevMode } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../app.config';
import { context } from 'bookingbug-core-js';
import { DatastoreService } from './datastore.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: "root",
})
export class CapitaService {
  private core = AppConfig.settings.core;
  private apiServer = AppConfig.settings.apiServer;
  //private url =
  // window.location.hostname == "localhost"
  //   ? "http://localhost:4201"
  // : "https://staging.bookinglab.co.uk";
  private url = "https://staging.bookinglab.co.uk";
  private path = "/";
  private config: any;
  capitaUrlPath =
    window.location.hostname.indexOf("staging") !== -1
      ? "/payment/"
      : "/payment/";

  constructor(
    private http: HttpClient,
    private datastoreService: DatastoreService,
    private configService: ConfigService,
  ) { }

  async invoke(company, booking, purchase, client, description, fundCode, price, vatOptOut, ref, extraItemBonuses, selectedService) {
    if (!fundCode) {
      fundCode = 'MISC';
    }

    let port = '';
    // '' is the default port for the scheme -- without it a plain https
    // page scored a stray ":" into the payment gateway URL.
    const ports: any = ['80', '443', ''];
    if (ports.indexOf(window.location.port) === -1) {
      port = `:${window.location.port}`;
    }

    this.config = await this.configService.getConfig();
    // let basePrice;
    // console.log(this.datastoreService);
    // if (this.config.community_venues.includes(selectedService.id)) {
    //   console.log('Community venue');
    //   // in the vatSplit array, find the item that has vat of 'Non-VAT' and the type of 'service'
    //   const nonVatService = this.datastoreService.vatSplit.find(item => item.vat === 'Non-VAT' && item.type === 'service');
    //   basePrice = nonVatService.cost * 100;
    // } 
    // (this.datastoreService.totalCost * 100)
    const body = {
      host: `${context.apiUrl}`,
      company_id: `${company.id}`,
      booking_id: `${booking.id}`,
      purchase_id: `${purchase.id}`,
      client_id: `${client.id}`,
      fund_code: `${fundCode}`,
      description: `${description}`,
      reference: `${ref}`,
      amount: price,
      send_user_details: false, // this adds the billingDetails element to the Capita XML with the card holder name and email pre-populated in the portal
      combine_reference: true,
      add_account_details: true, // This adds the accountName field to the lgItemDetails section of the Capita XML
      vat_opt_out: vatOptOut,
      do_not_store_ref: true,
      return_url: `${window.location.protocol}//${window.location.hostname}${port}${this.path}payment-verify?p=${purchase.id}&b=${booking.id}&c=${company.id}`,
      back_url: `${window.location.protocol}//${window.location.hostname}${port}${this.path}payment-verify?p=${purchase.id}&b=${booking.id}&c=${company.id}`
    }

    if (extraItemBonuses) {
      body["additionalCharges"] = [

      ]
      for (const extraItemBonus of extraItemBonuses) {
        body["additionalCharges"].push({
          "chargeName": extraItemBonus.item_name,
          "charge": extraItemBonus.chargePrice * 100,
          "reference": extraItemBonus.data.short_code
        })
        // non vat price + extraItemBonus.chargePrice * 100
        body["basePrice"] = price - extraItemBonus.chargePrice * 100;
      }

      // community venues
      if (this.config.community_venues.includes(selectedService.id)) {
        const vatService = this.datastoreService.vatSplit.find(item => item.vat === 'Standard-VAT' && item.type === 'service');
        body["additionalCharges"].push({
          "chargeName": vatService.item,
          "charge": vatService.cost * 100,
          "reference": vatService.budget_code,
          'vatCode': '1',
          "vatAmountInMinorUnits": (vatService.cost * 100) / 120 * 20
        })
        body["basePrice"] = body["basePrice"] - (vatService.cost * 100);
      }
    }

    return this.http.post(`${this.url}${this.capitaUrlPath}capita/invoke`, body).toPromise();

  }

  async query(paymentRef) {
    const body = {
      host: `${context.apiUrl}`,
      scp_id: paymentRef,
    };
    return this.http
      .post(`${this.url}${this.capitaUrlPath}capita/query`, body)
      .toPromise();
  }

  async find(purchaseId, companyId) {
    const body = {
      host: `${context.apiUrl}`,
      company_id: `${companyId}`,
      purchase_id: `${purchaseId}`,
    };

    return this.http
      .post(`${this.url}${this.capitaUrlPath}capita/find`, body)
      .toPromise();
  }

  async confirm(purchaseId, companyId, amount) {
    const body = {
      host: `${context.apiUrl}`,
      company_id: `${companyId}`,
      purchase_id: `${purchaseId}`,
      amount: amount,
    };

    return this.http
      .post(`${this.url}${this.capitaUrlPath}capita/confirm`, body)
      .toPromise();
  }


  async vatExemption(companyId, serviceItems) {
    const body = {
      host: `${context.apiUrl}`,
      company_id: `${companyId}`,
      service_items: serviceItems,
    };
    return this.http
      .post(`${this.url}${this.capitaUrlPath}capita/vat-exemption`, body)
      .toPromise();
  }
}
